import { LoadingOverlay } from 'foundations-components/transitional/components/LoadingOverlay';
import _get from 'hs-lodash/get';
import _isNil from 'hs-lodash/isNil';
import _omitBy from 'hs-lodash/omitBy';
import { useContext, useEffect, useMemo, useState } from 'react';
import { SCREENS } from '../../../constants/Tracking';
import { AppContext } from '../../../contexts/app/context';
import { PlaybooksPropsContext } from '../../../contexts/playbooks/PropsContext';
import { defaultPlaybooksProps } from '../../../contexts/playbooks/constants';
import { parseStringifiedObject } from '../../../utils/general';
import ContactSearch from '../../common/ContactSearch';
import PlaybookList from '../../common/playbooks/PlaybookList';
import PlaybooksInfoTooltip from '../PlaybooksInfoTooltip';
import { Container } from './Playbooks.style';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function Playbooks() {
  const {
    usageTracker,
    callObjectId,
    portalId,
    apiWrapper,
    openUrl
  } = useContext(PlaybooksPropsContext);
  const {
    appName,
    features
  } = useContext(AppContext);
  const [selectedContactId, setSelectedContactId] = useState('');
  useEffect(() => {
    usageTracker.trackPageView(SCREENS.playbooks);
  }, [usageTracker]);
  const onSelectContact = contact => {
    if (typeof contact === 'string') {
      const parsedContact = parseStringifiedObject(contact);
      const contactId = _get(parsedContact, 'id', '');
      setSelectedContactId(contactId.toString());
    } else {
      setSelectedContactId(contact.id);
    }
  };
  const additionalFilters = useMemo(() => ({
    filterGroups: [{
      filters: [{
        value: callObjectId,
        propertyName: 'associations.call',
        operator: 'EQ'
      }]
    }]
  }), [callObjectId]);
  if (!callObjectId) return /*#__PURE__*/_jsx(LoadingOverlay, {
    contextual: true
  });
  return /*#__PURE__*/_jsxs(Container, {
    "data-test-id": `${appName}-playbooks-page`,
    children: [/*#__PURE__*/_jsx(PlaybooksInfoTooltip, {}), /*#__PURE__*/_jsx(ContactSearch, {
      disabled: !features.PLAYBOOKS.available,
      selectContact: onSelectContact,
      additionalFilters: additionalFilters,
      appName: appName,
      searchObjectApi: apiWrapper.searchObject
    }), /*#__PURE__*/_jsx("br", {}), selectedContactId && /*#__PURE__*/_jsx(PlaybookList, {
      selectedObjectId: selectedContactId,
      callObjectId: callObjectId,
      usageTracker: usageTracker,
      portalId: portalId,
      openUrl: openUrl,
      apiWrapper: apiWrapper.playbooks
    })]
  });
}
const WrappedPlaybooks = props => {
  const definedProps = _omitBy(props, _isNil);
  return /*#__PURE__*/_jsx(PlaybooksPropsContext.Provider, {
    value: Object.assign({}, defaultPlaybooksProps, definedProps),
    children: /*#__PURE__*/_jsx(Playbooks, {})
  });
};
export default WrappedPlaybooks;